/**
 * Kinde Token Provider
 *
 * This module provides a way to access Kinde tokens from outside React components,
 * specifically for use in Redux baseQuery which doesn't have access to React hooks.
 *
 * The token getter function is set by the App component after Kinde initializes.
 */

type TokenGetter = () => Promise<string>;

let kindeTokenGetter: TokenGetter | null = null;

/**
 * Set the Kinde token getter function
 * This should be called once during app initialization
 */
export const setKindeTokenGetter = (getter: TokenGetter) => {
  kindeTokenGetter = getter;
};

/**
 * Get the current Kinde access token
 * Returns empty string if Kinde is not initialized or user is not authenticated
 */
export const getKindeToken = async (): Promise<string> => {
  if (!kindeTokenGetter) {
    console.warn("[KindeTokenProvider] Token getter not initialized");
    return "";
  }

  try {
    const token = await kindeTokenGetter();
    return token || "";
  } catch {
    console.error("Failed to retrieve Kinde token");
    return "";
  }
};
